/** @jsxImportSource @emotion/react */

'use client';

import { Box } from '@mui/material';
import type { ReactNode } from 'react';

import LogoColored from '@campaign-manager/app/ui/icons/logo-colored.svg';
import { ThemeProvider } from '@campaign-manager/app/ui/react/context/ThemeProvider';
import Link from '@campaign-manager/react/components/Link';

import { useProjectSettings } from '../../../context/ProjectSettingsContext';
import * as styles from './styles';

interface Props {
  children?: ReactNode;
}

export default function ErrorPageLayout({ children }: Props) {
  const { projectSettings } = useProjectSettings();
  return (
    <ThemeProvider projectSettings={projectSettings}>
      <Box css={styles.errorPage}>
        <Box>
          <Link href="/">
            {projectSettings?.logo_url ? (
              <img
                src={projectSettings.logo_url}
                css={styles.customLogo}
              />
            ) : (
              <LogoColored />
            )}
          </Link>
        </Box>
        {children}
      </Box>
    </ThemeProvider>
  );
}
